import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import { useParkingLotByCode } from '../services/use-parkinglot-by-code';

export type ParkingLotSearch = { parkinglotCode?: string; serialCode?: string };

const parseParkingLotSearch = (search: string) => {
  const { p: parkinglotCode, c: serialCode } = qs.parse(search);

  const isValid =
    typeof parkinglotCode === 'string' && typeof serialCode === 'string';

  return isValid ? { parkinglotCode, serialCode } : undefined;
};

export const useParkingLotSearch = () => {
  const location = useLocation();
  const parkingLotSearch = parseParkingLotSearch(location.search);

  return parkingLotSearch ?? ({} as ParkingLotSearch);
};

export const useParkingLotInfo = () => {
  const location = useLocation();
  const parkingLotSearch = parseParkingLotSearch(location.search);

  const { parkinglotCode, serialCode } = parkingLotSearch ?? {};

  const { parkingLot, ...query } = useParkingLotByCode(
    { parkinglotCode, serialCode },
    {
      enabled: !!parkinglotCode && !!serialCode,
    },
  );

  return {
    ...query,
    parkingLotInfo: parkingLot,
    isValidParkingLot: !!parkingLotSearch && !query.error,
  };
};
